import AppLayout from '../layouts/AppLayout'

const arme_tipo1 = 1
const arme_id1 = 3
const arme_tipo3 = 3
const arme_id3 = 68

export const informes = {
         path: '/informes',
         name: 'informes',
         component: AppLayout,
         meta: {
           requiresAuth: true
         },
         children: [
           {
             path: ':arme_tipo?/:arme_id?',
             name: 'informes.index',
             component: () =>
               import(
                 /* webpackChunkName: "informes.index" */ '@/views/new-menu/informe/Index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes'
                 }
               ]
             }
           },
           {
             path: 'reportespqrs/consolidados/:arme_tipo?/:arme_id?',
             name: 'informes.reportespqrs.consoliadados',
             component: () =>
               import(
                 /* webpackChunkName: "informes.reportespqrs.consoliadados" */ '@/views/informe/menu1consolidado/menu1-3reporte/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Consolidados'
                 }
               ]
             }
           },
           {
             path: 'reportespqrs/pendientes/:arme_tipo?/:arme_id?',
             name: 'informes.reportespqrs.pendientes',
             component: () =>
               import(
                 /* webpackChunkName: "informes.reportespqrs.pendientes" */ '@/views/proceso/menu2pendiente/menu2-1pendiente/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Pendientes'
                 }
               ]
             }
           },
           {
             path: 'reportespqrs/vencer/:arme_tipo?/:arme_id?',
             name: 'informes.reportespqrs.vencer',
             component: () =>
               import(
                 /* webpackChunkName: "informes.reportespqrs.vencer" */ '@/views/solicitud/menu4porvencer/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Por vencer'
                 }
               ]
             }
           },
           {
             path: 'reportespqrs/detallado/:arme_tipo?/:arme_id?',
             name: 'informes.reportespqrs.detallado',
             component: () =>
               import(
                 /* webpackChunkName: "informes.reportespqrs.detallado" */ '@/views/solicitud/menu3detallado/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Detallado'
                 }
               ]
             }
           },
           {
             path: 'operaciones/expansion/:arme_tipo?/:arme_id?',
             name: 'informes.operaciones.expansion',
             component: () =>
               import(
                 /* webpackChunkName: "informes.operaciones.expansion" */ '@/views/informe/menu2detallado/menu2-2expansion/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Expansion'
                 }
               ]
             }
           },
           {
             path: 'operaciones/modernizacion/:arme_tipo?/:arme_id?',
             name: 'informes.operaciones.modernizacion',
             component: () =>
               import(
                 /* webpackChunkName: "informes.operaciones.modernizacion" */ '@/views/informe/menu2detallado/menu2-4modernizacion/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Modernizacion'
                 }
               ]
             }
           },
           {
             path: 'operaciones/retiro/:arme_tipo?/:arme_id?',
             name: 'informes.operaciones.retiro',
             component: () =>
               import(
                 /* webpackChunkName: "informes.operaciones.retiro" */ '@/views/informe/menu2detallado/menu2-8retiro/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Retiro'
                 }
               ]
             }
           },
           {
             path: 'operaciones/reubicacion/:arme_tipo?/:arme_id?',
             name: 'informes.operaciones.reubicacion',
             component: () =>
               import(
                 /* webpackChunkName: "informes.operaciones.reubicacion" */ '@/views/informe/menu2detallado/menu2-3reubicacion/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Reubicacion'
                 }
               ]
             }
           },
           {
             path: 'operaciones/reposicion/:arme_tipo?/:arme_id?',
             name: 'informes.operaciones.reposicion',
             component: () =>
               import(
                 /* webpackChunkName: "informes.operaciones.reposicion" */ '@/views/informe/menu2detallado/menu2-6reposicion/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Reposicion'
                 }
               ]
             }
           },
           {
             path: 'operaciones/repotenciacion/:arme_tipo?/:arme_id?',
             name: 'informes.operaciones.repotenciacion',
             component: () =>
               import(
                 /* webpackChunkName: "informes.operaciones.repotenciacion" */ '@/views/informe/menu2detallado/menu2-7repotenciacion/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Repotenciacion'
                 }
               ]
             }
           },
           {
             path: 'operaciones/actualizacion/:arme_tipo?/:arme_id?',
             name: 'informes.operaciones.actualizacion',
             component: () =>
               import(
                 /* webpackChunkName: "informes.operaciones.actualizacion" */ '@/views/informe/menu2detallado/menu2-5actualizacion/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Actualizacion'
                 }
               ]
             }
           },
           {
             path: 'operaciones/medida/:arme_tipo?/:arme_id?',
             name: 'informes.operaciones.medida',
             component: () =>
               import(
                 /* webpackChunkName: "informes.operaciones.medida" */ '@/views/informe/menu2detallado/menu2-9cambiomedida/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Cambio de Medida'
                 }
               ]
             }
           },
           {
             path: 'operaciones/barrio/:arme_tipo?/:arme_id?',
             name: 'informes.operaciones.barrio',
             component: () =>
               import(
                 /* webpackChunkName: "informes.operaciones.barrio" */ '@/views/informe/menu2detallado/menu2-11porbarrio/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Por Barrio'
                 }
               ]
             }
           },
           {
             path: 'operaciones/detallado/:arme_tipo?/:arme_id?',
             name: 'informes.operaciones.detallado',
             component: () =>
               import(
                 /* webpackChunkName: "informes.operaciones.detallado" */ '@/views/informe/menu2detallado/menu2-17operaciones/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Detallado'
                 }
               ]
             }
           },
           {
             path: 'operaciones/resumenafaro/:arme_tipo?/:arme_id?',
             name: 'informes.operaciones.resumenafaro',
             component: () =>
               import(
                 /* webpackChunkName: "informes.operaciones.resumenafaro" */ '@/views/informe/menu1consolidado/menu1-7aforo/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Resumen Aforo'
                 }
               ]
             }
           },
           {
             path: 'operaciones/estadistico/comparativo/:arme_tipo?/:arme_id?',
             name: 'informes.operaciones.estadistico.comparativo',
             component: () =>
               import(
                 /* webpackChunkName: "informes.operaciones.estadistico.comparativo" */ '@/views/informe/menu1consolidado/menu1-6estadistica/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Estadistico Comparativo'
                 }
               ]
             }
           },
           {
             path: 'operaciones/estadistico/acumulado/:arme_tipo?/:arme_id?',
             name: 'informes.operaciones.estadistico.acumulado',
             component: () =>
               import(
                 /* webpackChunkName: "informes.operaciones.estadistico.acumulado" */ '@/views/informe/menu1consolidado/menu1-5operaciones/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Estadistico Acumulado'
                 }
               ]
             }
           },
           {
             path: 'inventarios/luminarias/:arme_tipo?/:arme_id?',
             name: 'informes.inventarios.luminarias',
             component: () =>
               import(
                 /* webpackChunkName: "informes.inventarios.luminarias" */ '@/views/informe/menu3inventario/menu3-1luminaria/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Luminarias'
                 }
               ]
             }
           },
           {
             path: 'inventarios/control/:arme_tipo?/:arme_id?',
             name: 'informes.inventarios.control',
             component: () =>
               import(
                 /* webpackChunkName: "informes.inventarios.control" */ '@/views/informe/menu3inventario/menu3-2control/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Control'
                 }
               ]
             }
           },
           {
             path: 'inventarios/transformador/:arme_tipo?/:arme_id?',
             name: 'informes.inventarios.transformador',
             component: () =>
               import(
                 /* webpackChunkName: "informes.inventarios.transformador" */ '@/views/informe/menu3inventario/menu3-6transformador/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Transformador'
                 }
               ]
             }
           },
           {
             path: 'inventarios/medidor/:arme_tipo?/:arme_id?',
             name: 'informes.inventarios.medidor',
             component: () =>
               import(
                 /* webpackChunkName: "informes.inventarios.medidor" */ '@/views/informe/menu3inventario/menu3-7medidor/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Medidor'
                 }
               ]
             }
           },
           {
             path: 'inventarios/postes/:arme_tipo?/:arme_id?',
             name: 'informes.inventarios.postes',
             component: () =>
               import(
                 /* webpackChunkName: "informes.inventarios.postes" */ '@/views/informe/menu3inventario/menu3-4poste/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Postes'
                 }
               ]
             }
           },
           {
             path: 'inventarios/informesporuso/:arme_tipo?/:arme_id?',
             name: 'informes.inventarios.informesporuso',
             component: () =>
               import(
                 /* webpackChunkName: "informes.inventarios.informesporuso" */ '@/views/gerencia/reporteporuso.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Informes por Uso'
                 }
               ]
             }
           },
           {
             path: 'fotografico/registro/:arme_tipo?/:arme_id?',
             name: 'informes.fotografico.registro',
             component: () =>
               import(
                 /* webpackChunkName: "informes.fotografico.registro" */ '@/views/informe/menu6foto/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Registro Fotografico'
                 }
               ]
             }
           },
           {
             path: 'ordendetrabajo/historica/:arme_tipo?/:arme_id?',
             name: 'informes.ordendetrabajo.historica',
             component: () =>
               import(
                 /* webpackChunkName: "informes.ordendetrabajo.historica" */ '@/views/proceso/menu4orden/menu4-2externa/menu4-2-1list/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Historico'
                 }
               ]
             }
           },
           {
             path: 'ordendetrabajo/cobranza/:arme_tipo?/:arme_id?',
             name: 'informes.ordendetrabajo.cobranza',
             component: () =>
               import(
                 /* webpackChunkName: "informes.ordendetrabajo.cobranza" */ '@/views/new-menu/informe/cobranza/Index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Cobranza'
                 }
               ]
             }
           },
           {
             path: 'ordendetrabajo/cobranza/cobro/:arme_tipo?/:arme_id?',
             name: 'informes.ordendetrabajo.cobranza.cobro',
             component: () =>
               import(
                 /* webpackChunkName: "informes.ordendetrabajo.cobranza.cobro" */ '@/views/proceso/menu4orden/menu4-3cobro/menu4-3-1list/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.ordendetrabajo.cobranza',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Cobranza',
                   to: {
                     name: 'informes.ordendetrabajo.cobranza',
                     params: { arme_tipo: arme_tipo3, arme_id: arme_id3 }
                   },
                   active: true
                 },
                 {
                   text: 'Cobro'
                 }
               ]
             }
           },
           {
             path: 'ordendetrabajo/cobranza/factura/:arme_tipo?/:arme_id?',
             name: 'informes.ordendetrabajo.cobranza.factura',
             component: () =>
               import(
                 /* webpackChunkName: "informes.ordendetrabajo.cobranza.factura" */ '@/views/proceso/menu4orden/menu4-3cobro/menu4-3-2factura/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.ordendetrabajo.cobranza',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Cobranza',
                   to: {
                     name: 'informes.ordendetrabajo.cobranza',
                     params: { arme_tipo: arme_tipo3, arme_id: arme_id3 }
                   },
                   active: true
                 },
                 {
                   text: 'Factura'
                 }
               ]
             }
           },
           {
             path:
               'ordendetrabajo/cobranza/actaredimensionamiento/:arme_tipo?/:arme_id?',
             name: 'informes.ordendetrabajo.cobranza.actaredimensionamiento',
             component: () =>
               import(
                 /* webpackChunkName: "informes.ordendetrabajo.cobranza.actaredimensionamiento" */ '@/views/proceso/menu4orden/menu4-3cobro/menu4-3-3acta/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.ordendetrabajo.cobranza',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Cobranza',
                   to: {
                     name: 'informes.ordendetrabajo.cobranza',
                     params: { arme_tipo: arme_tipo3, arme_id: arme_id3 }
                   },
                   active: true
                 },
                 {
                   text: 'Acta Redimensionamiento'
                 }
               ]
             }
           },
           {
             path: 'ordendetrabajo/actadesmonte/:arme_tipo?/:arme_id?',
             name: 'informes.ordendetrabajo.actadesmonte',
             component: () =>
               import(
                 /* webpackChunkName: "informes.ordendetrabajo.actadesmonte" */ '@/views/proceso/menu7actadesmonte/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Acta Desmonte'
                 }
               ]
             }
           },
           {
             path: 'materiales/detallado/:arme_tipo?/:arme_id?',
             name: 'informes.materiales.detallado',
             component: () =>
               import(
                 /* webpackChunkName: "informes.materiales.detallado" */ '@/views/informe/menu2detallado/menu2-1material/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Detallado'
                 }
               ]
             }
           },
           {
             path: 'materiales/utilizado/:arme_tipo?/:arme_id?',
             name: 'informes.materiales.utilizado',
             component: () =>
               import(
                 /* webpackChunkName: "informes.materiales.utilizado" */ '@/views/informe/menu1consolidado/menu1-1material/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Utilizado'
                 }
               ]
             }
           },
           {
             path: 'materiales/portipo/:arme_tipo?/:arme_id?',
             name: 'informes.materiales.portipo',
             component: () =>
               import(
                 /* webpackChunkName: "informes.materiales.portipo" */ '@/views/informe/menu1consolidado/menu1-10materialusadoporreti/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Por Tipo'
                 }
               ]
             }
           },
           {
             path: 'materiales/porbodega/:arme_tipo?/:arme_id?',
             name: 'informes.materiales.porbodega',
             component: () =>
               import(
                 /* webpackChunkName: "informes.materiales.porbodega" */ '@/views/informe/menu1consolidado/menu1-2portipo/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Por Bodega'
                 }
               ]
             }
           },
           {
             path: 'materiales/porcuadrilla/:arme_tipo?/:arme_id?',
             name: 'informes.materiales.porcuadrilla',
             component: () =>
               import(
                 /* webpackChunkName: "informes.materiales.porcuadrilla" */ '@/views/informe/menu1consolidado/menu1-8materialcuadrilla/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Por Cuadrilla'
                 }
               ]
             }
           },
           {
             path: 'materiales/porrepetido/:arme_tipo?/:arme_id?',
             name: 'informes.materiales.porrepetido',
             component: () =>
               import(
                 /* webpackChunkName: "informes.materiales.porrepetido" */ '@/views/informe/menu2detallado/menu2-12repetido/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Por Repetido'
                 }
               ]
             }
           },
           {
             path: 'actas/liquidacionaom/:arme_tipo?/:arme_id?',
             name: 'informes.actas.liquidacionaom',
             component: () =>
               import(
                 /* webpackChunkName: "informes.actas.liquidacionaom" */ '@/views/actas/acta-aom/Index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Acta AOM'
                 }
               ]
             }
           },
           {
             path: 'actas/valorinfra/:arme_tipo?/:arme_id?',
             name: 'informes.actas.valorinfra',
             component: () =>
               import(
                 /* webpackChunkName: "informes.actas.valorinfra" */ '@/views/actas/acta-valorizacion-infraestructura/Index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Acta Valorización Infraestructura'
                 }
               ]
             }
           },
           {
             path: 'actas/flujoejecutado/:arme_tipo?/:arme_id?',
             name: 'informes.actas.actaflujocajaejecutado',
             component: () =>
               import(
                 /* webpackChunkName: "informes.actas.actaflujocajaejecutado" */ '@/views/new-menu/informe/actas/flujo-caja-ejecutado/Index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Acta Flujo Caja Ejecutado'
                 }
               ]
             }
           },
           {
             path: 'actas/flujovigente/:arme_tipo?/:arme_id?',
             name: 'informes.actas.actaflujocajavigente',
             component: () =>
               import(
                 /* webpackChunkName: "informes.actas.actaflujocajavigente" */ '@/views/new-menu/informe/actas/flujo-caja-vigente/Index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Acta Flujo Caja Vigente'
                 }
               ]
             }
           },
           {
             path: 'reportespqrs/ejecutado/:arme_tipo?/:arme_id?',
             name: 'informes.reportespqrs.ejecutado',
             component: () =>
               import(
                 /* webpackChunkName: "informes.reportespqrs.ejecutado" */ '@/views/proceso/menu2pendiente/menu2-2ejecutado/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Ejecutado'
                 }
               ]
             }
           },
           {
             path: 'reportespqrs/cambios/:arme_tipo?/:arme_id?',
             name: 'informes.reportespqrs.cambios',
             component: () =>
               import(
                 /* webpackChunkName: "informes.reportespqrs.cambios" */ '@/views/proceso/menu2pendiente/menu2-3informecambios/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Cambios'
                 }
               ]
             }
           },
           {
             path: 'reportespqrs/obrapendiente/:arme_tipo?/:arme_id?',
             name: 'informes.reportespqrs.obrapendiente',
             component: () =>
               import(
                 /* webpackChunkName: "informes.reportespqrs.obrapendiente" */ '@/views/proceso/menu3obra/menu3-4pendiente/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Obra Pendiente'
                 }
               ]
             }
           },
           {
             path: 'reportespqrs/reportessinot/:arme_tipo?/:arme_id?',
             name: 'informes.reportespqrs.reportessinot',
             component: () =>
               import(
                 /* webpackChunkName: "informes.reportespqrs.reportessinot" */ '@/views/informe/menu2detallado/menu2-16reportesinot/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Reportes sin OT'
                 }
               ]
             }
           },
           {
             path: 'fotografico/sinfoto/:arme_tipo?/:arme_id?',
             name: 'informes.fotografico.sinfoto',
             component: () =>
               import(
                 /* webpackChunkName: "informes.fotografico.sinfoto" */ '@/views/informe/menu1consolidado/menu1-9reportesinfoto/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Registro Fotografico Sin Foto'
                 }
               ]
             }
           },
           {
             path: 'inventarios/geoposicionamiento/:arme_tipo?/:arme_id?',
             name: 'informes.inventarios.geoposicionamiento',
             component: () =>
               import(
                 /* webpackChunkName: "informes.inventarios.geoposicionamiento" */ '@/views/inventario/menu1luminaria/menu1-5geo/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Geoposicionamiento'
                 }
               ]
             }
           },
           {
             path: 'inventarios/calculounidad/:arme_tipo?/:arme_id?',
             name: 'informes.inventarios.calculounidad',
             component: () =>
               import(
                 /* webpackChunkName: "informes.inventarios.calculounidad" */ '@/views/informe/menu4calculo/menu4-4ucap/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Calculo Unidad Constructiva'
                 }
               ]
             }
           },
           {
             path: 'inventarios/ucaps/:arme_tipo?/:arme_id?',
             name: 'informes.inventarios.ucaps',
             component: () =>
               import(
                 /* webpackChunkName: "informes.inventarios.ucaps" */ '@/views/administracion/ucap.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Ucaps'
                 }
               ]
             }
           },
           {
             path: 'inventarios/ucaps/crear',
             name: 'inventarios.ucaps.crear',
             component: () =>
               import(
                 /* webpackChunkName: "inventarios.ucaps.crear" */ '@/views/administracion/ucap/create.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Ucaps',
                   to: { name: 'informes.inventarios.ucaps' },
                   active: true
                 },
                 {
                   text: 'Crear Ucaps'
                 }
               ]
             }
           },
           {
             path: 'inventarios/ucaps/editar/:ucap_id?',
             name: 'inventarios.ucaps.editar',
             component: () =>
               import(
                 /* webpackChunkName: "inventarios.ucaps.editar" */ '@/views/administracion/ucap/edit.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Grabar',
                   to: {
                     name: 'grabar.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   }
                 },
                 {
                   text: 'Ucaps',
                   to: { name: 'informes.inventarios.ucaps' },
                   active: true
                 },
                 {
                   text: 'Editar Ucaps'
                 }
               ]
             }
           },
           {
             path: 'reportespqrs/retirovsreu/:arme_tipo?/:arme_id?',
             name: 'informes.reportespqrs.retirovsreu',
             component: () =>
               import(
                 /* webpackChunkName: "informes.reportespqrs.retirovsreu" */ '@/views/informe/menu2detallado/menu2-10retirovsreubicacion/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Retiro vs Reubicacion'
                 }
               ]
             }
           },
           {
             path: 'reportespqrs/luminarias/:arme_tipo?/:arme_id?',
             name: 'informes.reportespqrs.luminarias',
             component: () =>
               import(
                 /* webpackChunkName: "informes.reportespqrs.luminarias" */ '@/views/informe/menu2detallado/menu2-14luminariareporte/index.vue'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Luminarias'
                 }
               ]
             }
           },
           {
             path: 'reportespqrs/luminarias/encendidas/:arme_tipo?/:arme_id?',
             name: 'informes.reportespqrs.encendidas',
             component: () =>
               import(
                 /* webpackChunkName: "informes.reportespqrs.encendidas" */ '@/views/interventoria/menu2informe/menu2-2detallado/menu2-2-1encendidas'
               ),
             meta: {
               breadcrumb: [
                 {
                   text: 'Dashboard',
                   to: { name: 'dashboard' },
                   active: true
                 },
                 {
                   text: 'Informes',
                   to: {
                     name: 'informes.index',
                     params: { arme_tipo: arme_tipo1, arme_id: arme_id1 }
                   },
                   active: true
                 },
                 {
                   text: 'Luminarias'
                 }
               ]
             }
           }
         ]
       }
